import { MercatoSurveyDetail as MercatoSurveyDetailComponent } from './MercatoSurveyDetail.component';
import { connector } from './MercatoSurveyDetail.connector';

export const MercatoSurveyDetail = connector(MercatoSurveyDetailComponent);
